import 'codemirror/lib/codemirror.css';
import 'codemirror/theme/material.css';
import 'codemirror/mode/jsx/jsx';
import React, { useState, useEffect } from 'react';
import { Controlled as CodeMirror } from 'react-codemirror2';
import { Alert } from 'reactstrap';
import axios from 'axios';
import { useDebounce } from './hooks/use-debounce';
import RenderInViewport from './render-in-viewport';

const SERVER_URL =
  process.env.NODE_ENV === 'production'
    ? 'https://real-react-editor-server.herokuapp.com'
    : 'http://localhost:4000';

const postCode = async (code) => {
  const { data } = await axios.post(SERVER_URL, {
    code,
  });

  return data.key;
};

export default ({ children }) => {
  const [value, setValue] = useState(children || '');
  const [debouncedValue] = useDebounce(value, 1000);
  const [err, setErr] = useState('');
  const [key, setKey] = useState('');

  useEffect(() => {
    const req = async () => {
      try {
        const newKey = await postCode(debouncedValue);
        setKey(newKey);
        setErr('');
      } catch (error) {
        if (
          error.response &&
          error.response.data &&
          error.response.data.error
        ) {
          setErr(error.response.data.error);
        }
      }
    };

    req();
  }, [debouncedValue]);

  return (
    <div className="editor-wrapper">
      <div className="editor-left">
        <CodeMirror
          value={value}
          options={{
            lineNumbers: true,
            mode: 'jsx',
            theme: 'material',
          }}
          onBeforeChange={(_editor, _data, newValue) => {
            setValue(newValue);
          }}
        />
        {err ? (
          <Alert className="code-error" color="danger">
            {err}
          </Alert>
        ) : null}
      </div>

      {key ? <iframe title="editor" src={`${SERVER_URL}/${key}`} /> : null}
    </div>
  );
};
